import React, { Component } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
// import "../styleSheets/EmsDetail.css";

export default class EmsDetail extends Component {
  constructor() {
    super();
    this.state = {
      grid: true,
      dailogOpen: false,
    };

    this.toggle = this.toggle.bind(this);
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClickOpen = () => {
    this.setState({ dailogOpen: true });
  };

  handleClose = () => {
    this.setState({ dailogOpen: false });
  };
  toggle() {
    this.setState({ grid: !this.state.grid });
    if (this.state.grid == false) {
      document.getElementById("gridConn").style.visibility = "hidden";
    } else {
      document.getElementById("gridConn").style.visibility = "visible";
    }
  }

  render() {
    return (
      <div>
        <h1>EmsDetail</h1>
        <Box sx={{ flexGrow: 1, marginTop: "50px" }}>
          <Grid
            container
            spacing={0}
            direction="row"
            alignItems="center"
            justifyContent="center"
          >
            <Grid item xs={12} sm={12} md={12} lg={1}>
              <Paper
                elevation={0}
                sx={{ padding: "30px", backgroundColor: "#edf1f3" }}
              >
                <div style={{ textAlign: "center" }}>Solar</div>
                {/* <div class="circle">
                                    <div class="circle__inner">
                                        <div class="circle__wrapper">
                                            <div class="circle__content">Circle text</div>
                                        </div>
                                    </div>
                                </div> */}
                {/* <div>1 kw </div> */}
              </Paper>
            </Grid>
            <Grid item>
              <ul>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
              </ul>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={1}>
              <Paper sx={{ padding: "30px", backgroundColor: "#edf1f3" }}>
                <div style={{ textAlign: "center" }}>Grid</div>
              </Paper>
            </Grid>
            <Grid item id="gridConn">
              <ul>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
              </ul>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={1}>
              <Paper sx={{ padding: "30px", backgroundColor: "#edf1f3" }}>
                <div style={{ textAlign: "center" }}>EMS</div>
              </Paper>
            </Grid>
            <Grid item>
              <ul>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
              </ul>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={1}>
              <Paper sx={{ padding: "30px", backgroundColor: "#edf1f3" }}>
                <div style={{ textAlign: "center" }}>Load</div>
              </Paper>
            </Grid>
          </Grid>
        </Box>
        <button onClick={this.toggle}>Toggle</button>
        {/* ================================================= */}
        <Button variant="outlined" onClick={this.handleClickOpen}>
          Slide in alert dialog
        </Button>
        <Dialog
          open={this.state.dailogOpen}
          // TransitionComponent={Transition}
          keepMounted
          onClose={this.handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>{"Use Google's location service?"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              Let Google help apps determine location. This means sending
              anonymous location data to Google, even when no apps are running.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose}>Disagree</Button>
            <Button onClick={this.handleClose}>Agree</Button>
          </DialogActions>
        </Dialog>

        {/* ================================================= */}
      </div>
    );
  }
}
